namespace Solovis.Portal.TxServices {

    export interface GroupedTxViewEditModelOptions {
        groupedTxListViewEditModel?: GroupedTxListViewEditModel;
        tx?: TransactionEntryEditModel;
    }

    export class GroupedTxViewEditModel {
        public _groupedTxListViewEditModel: GroupedTxListViewEditModel;

        private _investmentId: number;
        private _transactionEntryId: number;
        private _transactionEntryResourceId: number;
        public editId: string | null;
        private _effectiveDayId: number;
        private _effectiveTimeUtc: Date | number | null;
        private _transactionTypeTagId: number;
        private _transactionTypeTagSetId: number;
        private _amountIn: number | string;
        private _amountOut: number | string;
        private _units: number | string;
        private _unitPrice: number | string;
        private _isInternalFlow: boolean;
        private _isStock: boolean;
        private _commitmentExcluded: boolean;
        private _recallableAmount: string;
        private _netIncomeIn: number | string;
        private _isStartOfDay: boolean;
        private _storedFxRate: string;
        private _fxRate: string;
        private _txComment: string;
        private _isAdjustment: boolean;
        private _reviewedBy: number | null;

        private _editLabel;

        private _propDefIdToCustomValueMap: Record<number, any>;
        private _originalPropDefIdToCustomValueMap: Record<number, any>;


        // TODO: Declare set of system tag set ids in InvData.
        public static defaultTxTypeTagSetId = 102;


        constructor(options: GroupedTxViewEditModelOptions) {
            const tx: TransactionEntryEditModel = options.tx;

            this._groupedTxListViewEditModel = options.groupedTxListViewEditModel ? options.groupedTxListViewEditModel : null;

            const portalServices = this._groupedTxListViewEditModel.portalServices();

            this._investmentId = tx.investmentId ? tx.investmentId : null;
            this._transactionEntryId = tx.transactionEntryId ? tx.transactionEntryId : null;
            this._transactionEntryResourceId = tx.transactionEntryResourceId ? tx.transactionEntryResourceId : null;
            this.editId = tx.transactionEntryId ? null :
                (tx.editId ? tx.editId : _.uniqueId("_GroupedTxViewEditModel_"));

            this._effectiveDayId = tx.effectiveDayId ? tx.effectiveDayId : null;
            this._effectiveTimeUtc = tx.effectiveTimeUtc ? tx.effectiveTimeUtc : null;
            this._transactionTypeTagId = tx.transactionTypeTagId ? tx.transactionTypeTagId : null;
            this._transactionTypeTagSetId = tx.transactionTypeTagSetId ? tx.transactionTypeTagSetId : GroupedTxViewEditModel.defaultTxTypeTagSetId;
            this._amountIn = tx.amountIn ? tx.amountIn.toString() : "0";
            this._amountOut = tx.amountOut ? tx.amountOut.toString() : "0";
            this._units = tx.units ? tx.units.toString() : null;
            this._unitPrice = tx.unitPrice ? tx.unitPrice.toString() : null;
            this._isInternalFlow = tx.isInternalFlow ? true : false;
            this._isStock = tx.isStock ? true : false;
            this._commitmentExcluded = tx.commitmentExcluded ? true : false;
            this._recallableAmount = tx.recallableAmount ? tx.recallableAmount.toString() : "0";
            this._netIncomeIn = tx.netIncomeIn ? tx.netIncomeIn.toString() : "0";
            this._isStartOfDay = Solovis.isNotNull(tx.isStartOfDay) ? !!tx.isStartOfDay : TxSettings.defaultTxIsStartOfDay(portalServices);
            this._fxRate = tx.fxRate ? tx.fxRate.toString() : null;
            this._storedFxRate = tx.storedFxRate ? tx.storedFxRate.toString() : null;
            this._txComment = tx.txComment ? tx.txComment.toString() : null;
            this._isAdjustment = tx.isAdjustment ? true : false;

            this._reviewedBy = tx.reviewedBy ?? null;

            this._propDefIdToCustomValueMap = {};
            this._originalPropDefIdToCustomValueMap = {};
            if (tx.customPropValues) {
                for (let customPropValue of tx.customPropValues) {
                    this._propDefIdToCustomValueMap[customPropValue.propDefId] = customPropValue.value;
                    this._originalPropDefIdToCustomValueMap[customPropValue.propDefId] = customPropValue.value;
                }
            }
        }


        public getTxListViewEditModel(): GroupedTxListViewEditModel {
            return this._groupedTxListViewEditModel;
        }

        public getReviewedBy = () => {
          return this._reviewedBy;
        }



        public investmentId(investmentId?) {
            if (!arguments.length) {
                return this._investmentId;
            }
            else {
                if (Solovis.isNotNull(investmentId)) {
                    var newInvestmentId = parseInt(investmentId);
                    this._investmentId = newInvestmentId;
                }
                else {
                    this._investmentId = null;
                }
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public transactionEntryId(transactionEntryId?) {
            if (!arguments.length) {
                return this._transactionEntryId;
            }
            else {
                if (isNaN(transactionEntryId)) {
                    throw "invalid transaction Id.";
                }
                this._transactionEntryId = transactionEntryId;
                this.editId = null;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public effectiveDayId(effectiveDayId?) {
            if (!arguments.length) {
                return this._effectiveDayId;
            }
            else {
                if (isNaN(effectiveDayId)) {
                    throw "Invalid date format.";
                }
                this._effectiveDayId = effectiveDayId;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public effectiveTimeUtc(effectiveTimeUtc?) {
            if (!arguments.length) {
                return this._effectiveTimeUtc;
            }
            else {
                var newTimeUtc = new Date(effectiveTimeUtc);
                if (isNaN(newTimeUtc.valueOf())) {
                    throw "Invalid date format.";
                }
                this._effectiveTimeUtc = newTimeUtc;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public transactionTypeTagId(transactionTypeTagId?) {
            if (!arguments.length) {
                return this._transactionTypeTagId;
            }
            else {
                let newTagId = null;
                if (Solovis.isNotNull(transactionTypeTagId)) {
                    newTagId = parseInt(transactionTypeTagId);
                }
                this._transactionTypeTagId = newTagId;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public transactionTypeTagSetId(transactionTypeTagSetId?) {
            if (!arguments.length) {
                return this._transactionTypeTagSetId;
            }
            else {
                if (isNaN(transactionTypeTagSetId)) {
                    throw "invalid tag set Id.";
                }
                var newTagSetId = parseInt(transactionTypeTagSetId);
                this._transactionTypeTagSetId = newTagSetId;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public amountIn(amountIn?) {
            if (!arguments.length) {
                return this._amountIn;
            }
            else {
                if (Solovis.isNull(amountIn)) {
                    amountIn = "0";
                }

                this._amountIn = amountIn.toString();
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public amountOut(amountOut?) {
            if (!arguments.length) {
                return this._amountOut;
            }
            else {
                if (Solovis.isNull(amountOut)) {
                    amountOut = "0";
                }

                this._amountOut = amountOut.toString();
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public units(units?) {
            if (!arguments.length) {
                return this._units;
            }
            else {
                this._units = units ? units.toString() : null;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public unitPrice(unitPrice?) {
            if (!arguments.length) {
                return this._unitPrice;
            }
            else {
                this._unitPrice = unitPrice ? unitPrice.toString() : null;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public isInternalFlow(isInternalFlow?) {
            if (!arguments.length) {
                return this._isInternalFlow;
            }
            else {
                this._isInternalFlow = isInternalFlow ? true : false;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public isStock(isStock?) {
            if (!arguments.length) {
                return this._isStock;
            }
            else {
                this._isStock = isStock ? true : false;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public commitmentExcluded(commitmentExcluded?) {
            if (!arguments.length) {
                return this._commitmentExcluded;
            }
            else {
                this._commitmentExcluded = commitmentExcluded ? true : false;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public recallableAmount(recallableAmount?) {
            if (!arguments.length) {
                return this._recallableAmount;
            }
            else {
                if (Solovis.isNull(recallableAmount)) {
                    recallableAmount = "0";
                }

                this._recallableAmount = recallableAmount.toString();
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }

        public netIncomeIn(netIncomeIn?) {
            if (!arguments.length) {
                return this._netIncomeIn;
            }
            else {
                if (Solovis.isNull(netIncomeIn)) {
                    netIncomeIn = "0";
                }

                this._netIncomeIn = netIncomeIn.toString();
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public isStartOfDay(isStartOfDay?) {
            if (!arguments.length) {
                return this._isStartOfDay;
            }
            else {
                this._isStartOfDay = isStartOfDay ? true : false;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public storedFxRate(fxRate?) {
            if (!arguments.length) {
                return this._storedFxRate;
            }
            else {
                this._storedFxRate = fxRate ? fxRate.toString() : null;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public fxRate(fxRate?) {
            if (!arguments.length) {
                return this._fxRate;
            }
            else {
                this._fxRate = fxRate ? fxRate.toString() : null;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public txComment(txComment?) {
            if (!arguments.length) {
                return this._txComment;
            }
            else {
                this._txComment = txComment;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public isAdjustment(isAdjustment?) {
            if (!arguments.length) {
                return this._isAdjustment;
            }
            else {
                this._isAdjustment = isAdjustment ? true : false;
                this._groupedTxListViewEditModel.notifyModelChanged({
                    operation: "transactionEdit",
                    transaction: this
                });
            }
            return null;
        }


        public getId() {
            var result = {
                editId: false,
                value: null
            };

            if (Solovis.isNotNull(this.editId)) {
                result.editId = true;
                result.value = this.editId;
            }
            else {
                var txId = this.transactionEntryId();
                if (Solovis.isNotNull(txId)) {
                    result.value = txId;
                }
            }
            if (result.value === null) {
                throw "GroupedTxViewEditModel has no editId and no transactionEntryId.";
            }
            return result;
        }


        public isPrimary() {
            var primaryTransactionEntryId = this._groupedTxListViewEditModel.primaryTransactionEntryId();
            var primaryTransactionEditId = this._groupedTxListViewEditModel.primaryTransactionEditId();
            if (Solovis.isNotNull(primaryTransactionEntryId)) {
                if (this.transactionEntryId() === primaryTransactionEntryId) {
                    return true;
                }
            }
            else if (Solovis.isNotNull(primaryTransactionEditId)) {
                if (this.editId === primaryTransactionEditId) {
                    return true;
                }
            }
            return false;
        }

        public equalById(otherTxViewEditModel) {
            var myTxEntryId = this.transactionEntryId();
            var otherTxEntryId = otherTxViewEditModel.transactionEntryId();
            if (Solovis.isNotNull(myTxEntryId) && Solovis.isNotNull(otherTxEntryId)) {
                if (myTxEntryId === otherTxEntryId) {
                    return true;
                }
            }

            if (Solovis.isNotNull(this.editId) && Solovis.isNotNull(otherTxViewEditModel.editId)) {
                if (this.editId === otherTxViewEditModel.editId) {
                    return true;
                }
            }

            return false;
        }

        public togglePrimary(toggleValue) {
            var self = this;
            if (toggleValue === true) {
                var txEntryId = this.transactionEntryId();

                if (Solovis.isNotNull(txEntryId)) {
                    this._groupedTxListViewEditModel.primaryTransactionEntryId(txEntryId);
                }

                else {
                    this._groupedTxListViewEditModel.primaryTransactionEditId(this.editId);
                }
            }
            else if (toggleValue === false) {
                this._groupedTxListViewEditModel.primaryTransactionEntryId(null);
                this._groupedTxListViewEditModel.primaryTransactionEditId(null);
            }
        }

        public getTransactionNumericData() {
            throw "Not implemented.";
        }

        public validate() {
            var validationResults = {
                isValid: true,
                errorMessage: ""
            }

            if (Solovis.isNull(this.effectiveDayId())) {
                validationResults.isValid = false;
                validationResults.errorMessage = "Effective Date is required.";
            }

            return validationResults;
        }

        public editLabel() {
            var self = this;

            if (Solovis.isNotNull(this._editLabel)) {
                return this._editLabel;
            }
            var txEntryId = this.transactionEntryId();
            if (Solovis.isNotNull(txEntryId)) {
                this._editLabel = txEntryId;
                return this._editLabel;
            }

            // If we do not have a transaction entry Id, return a unique (to the list) letter.
            var index = this._groupedTxListViewEditModel.indexOf(this);
            if (index > -1) {
                if (index < 26) {
                    this._editLabel = String.fromCharCode(65 + index);
                }
                else {
                    index = index - 26;
                    this._editLabel = String.fromCharCode(97 + index);
                }
            }
            // Make sure this editLabel doesn't already exist
            $(this._groupedTxListViewEditModel.groupedTxViewEditModels()).each(function () {
                if (!this.equalById(self)) {
                    if (this.editLabel() === self._editLabel) {
                        var charCode = self._editLabel.charCodeAt(0);
                        charCode++;
                        if (charCode < 91) {
                            self._editLabel = String.fromCharCode(charCode);
                        }
                        else {
                            charCode = charCode - 91;
                            self._editLabel = String.fromCharCode(97 + charCode);
                        }
                    }
                }
            });

            return this._editLabel;
        }

        public getCustomPropValue(propDefId: number) {
            return this._propDefIdToCustomValueMap[propDefId];
        }

        public getOriginalCustomPropValue(propDefId: number){
            return this._originalPropDefIdToCustomValueMap[propDefId];
        }

        public getAllCustomPropValues() {
            return this._propDefIdToCustomValueMap;
        }

        public setCustomPropValue(propDefId: number, value: any) {
            this._propDefIdToCustomValueMap[propDefId] = value;

            this._groupedTxListViewEditModel.notifyModelChanged({
                operation: "transactionEdit",
                transaction: this
            });
        }


        public calculateNetAmountInAsNumber(): number {
            let amountIn = this.amountIn();
            let amountOut = this.amountOut();

            if (typeof (amountIn) === "string") {
                amountIn = InvData.DecimalHelper.decimalStringAsNumber(amountIn, true);
            }
            if (typeof (amountOut) === "string") {
                amountOut = InvData.DecimalHelper.decimalStringAsNumber(amountOut, true);
            }

            if (Solovis.isNotNull(amountIn) && Solovis.isNotNull(amountOut)) {
                let netAmountIn = amountIn - amountOut;
                return netAmountIn;
            }
            else {
                return null;
            }
        }

        public calculateNetAmountInAsString(): number | string {
            let netAmountIn = this.calculateNetAmountInAsNumber();
            if (isNull(netAmountIn)) {
                return null;
            }

            let amountIn = this.amountIn();
            let amountOut = this.amountOut();

            // If amountIn or amountOut is null or 0, we can preserve original input string.
            if (InvData.DecimalHelper.isNullOrZero(amountOut)) {
                return amountIn;
            }
            else if (InvData.DecimalHelper.isNullOrZero(amountIn)) {
                let negAmountOut = InvData.DecimalHelper.negate(amountOut);
                return negAmountOut;
            }

            let scaleToUse = InvData.DecimalHelper.getScale(amountIn);
            scaleToUse = Math.max(scaleToUse, InvData.DecimalHelper.getScale(amountOut));

            let netAmountInStr = InvData.DecimalHelper.clampNumberToScaleAsString(netAmountIn, scaleToUse);
            netAmountInStr = InvData.DecimalHelper.fixupThousandsSeparatorAsNumberString(netAmountInStr);

            return netAmountInStr;
        }


        public getTransactionData(): TransactionEntryEditModel {
            var txData: TransactionEntryEditModel = {
                investmentId: this.investmentId(),
                transactionEntryId: this.transactionEntryId(),
                transactionEntryResourceId: this._transactionEntryResourceId,
                editId: this.editId,
                effectiveDayId: this.effectiveDayId(),
                effectiveTimeUtc: this.effectiveTimeUtc() as number,
                transactionTypeTagId: this.transactionTypeTagId(),
                amountIn: this.amountIn(),
                amountOut: this.amountOut(),
                units: this.units(),
                unitPrice: this.unitPrice(),
                isInternalFlow: this.isInternalFlow(),
                isStock: this.isStock(),
                commitmentExcluded: this.commitmentExcluded(),
                recallableAmount: this.recallableAmount(),
                netIncomeIn: this.netIncomeIn(),
                transactionTypeTagSetId: this.transactionTypeTagSetId(),
                isStartOfDay: this.isStartOfDay(),
                fxRate: this.fxRate(),
                storedFxRate: this.storedFxRate(),
                txComment: this.txComment(),
                isAdjustment: this.isAdjustment()
            };

            let propDefIdsToEdit = this.getTxListViewEditModel().getPropDefIdsToEdit();
            if (!_.isEmpty(propDefIdsToEdit)) {
                let customPropValues: TxCustomPropValue[] = [];
                for (let propDefId of propDefIdsToEdit) {
                    let value = this.getCustomPropValue(propDefId);
                    customPropValues.push({
                        propDefId: propDefId,
                        value: value
                    });
                }

                txData.customPropValues = customPropValues;
            }

            return txData;
        }

        public getTransactionDataToSave(): TransactionEntryEditModel {
            var txData: TransactionEntryEditModel = {
                investmentId: this.investmentId(),
                transactionEntryId: this.transactionEntryId(),
                transactionEntryResourceId: this._transactionEntryResourceId,
                editId: this.editId,
                effectiveDayId: this.effectiveDayId(),
                effectiveTimeUtc: this.effectiveTimeUtc() as number,
                transactionTypeTagId: this.transactionTypeTagId(),
                amountIn: this.amountIn(),
                amountOut: this.amountOut(),
                units: this.units(),
                unitPrice: this.unitPrice(),
                isInternalFlow: this.isInternalFlow(),
                isStock: this.isStock(),
                commitmentExcluded: this.commitmentExcluded(),
                recallableAmount: this.recallableAmount(),
                netIncomeIn: this.netIncomeIn(),
                transactionTypeTagSetId: this.transactionTypeTagSetId(),
                isStartOfDay: this.isStartOfDay(),
                fxRate: this.fxRate(),
                storedFxRate: this.storedFxRate(),
                txComment: this.txComment(),
                isAdjustment: this.isAdjustment()
            };

            let propDefIdsToEdit = this.getTxListViewEditModel().getPropDefIdsToEdit();
            if (!_.isEmpty(propDefIdsToEdit)) {
                let customPropValues: TxCustomPropValue[] = [];
                for (let propDefId of propDefIdsToEdit) {
                    let value = this.getCustomPropValue(propDefId);
                    // check if value has changed
                    let orgValue = this.getOriginalCustomPropValue(propDefId);
                    if(value !== orgValue){
                        customPropValues.push({
                            propDefId: propDefId,
                            value: value
                        });
                    }                    
                }

                txData.customPropValues = customPropValues;
            }

            return txData;
        }
    }

}